<template>
    <div class="bg-light">
        <div class="container">
            <div class="row align-items-center">
                <div class="breadcrumbs col-12 d-flex align-items-center gap-2 py-3 mt-2">
                    <div v-for="breadcrumb, key in breadcrumbs">
                        <div class="d-inline" v-if="key === breadcrumbs.length - 1">
                            <span class="current fw-bold">{{ breadcrumb.name }}</span>
                        </div>
                        <div class="d-inline" v-else>
                            <div class="d-inline" v-if="breadcrumb.link">
                                <a class="d-inline-block text-black" :href="breadcrumb.link">{{ breadcrumb.name }}</a> <i class="fa-light fa-arrow-right"></i>
                            </div>
                            <div class="d-inline" v-else>
                                <span>{{ breadcrumb.name }} <i class="fa-solid fa-arrow-right"></i> </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <img :src="manufacturerBackgroundImage" alt="Manufacturer Hero Image" class="w-100 rounded-5 mb-2 mb-md-4" />
                </div>
                <div class="col-12 col-sm-6">
                    <h1 class="mt-5 mb-4 ps-sm-4">{{ manufacturer.heading ? manufacturer.heading : manufacturer.name }}</h1>
                    <div v-html="manufacturer.content" class="fw-light ps-sm-4"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <br>
        <slimline-reg-size-form :postcode="postcode" :options="options" :image-base-path="tyreImagePath"></slimline-reg-size-form>
        <br class="clear"/>
        <p class="py-2" v-if="manufacturer.secondary_content" v-html="manufacturer.secondary_content"></p>
        <div class="brand-content" v-if="manufacturerBrands.length > 0">
            <h2 class="my-4">Find your {{ manufacturer.name }}</h2>
            <div class="row">
                <div class="col-6 col-sm-4 col-md-3 col-xxl-2" v-for="brand, key in manufacturerBrands" :key="key">
                    <a :href="'/' + brand.slug" :title="brand.name">
                        <img class="brand-image img-fluid mb-3" :src="brandImagePath + (brand.brand_image != null ? brand.brand_image : 'generic.png')" :alt="brand.name + ' logo'" />
                    </a>
                </div>
            </div>
        </div>
        <br class="clear"/>
        <div v-if="carRanges.length > 0" class="models">
            <div class="row">
                <div class="col-12">
                    <h2 class="h3 mb-3">Find your {{ manufacturer.name }}</h2>
                </div>
                <div class="col-12 col-md-6 col-lg-3 mb-3" v-for="model, key in carRanges" :key="key">
                    <div class="card p-3">
                        <img :src="(tyreImagePath + (model.range_image != null ? model.range_image : 'Cars/template-car.png'))" :alt="manufacturer.name + ' ' + model.range_name" />
                        <h4 class="d-block text-center mt-2 mb-3">{{ manufacturer.name }} {{ model.range_name }}</h4>
                        <a class="btn btn-primary" :href="'/manufacturers/' + manufacturer.slug + '/' + model.range_slug" :title="model.range_name">
                            View tyres
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <br class="clear"/>
    </div>
</template>

<script>
    export default {
        props: [
            'manufacturer',
            'manufacturerBrands',
            'options',
            'banners',
            'webName',
            'carRanges',
            'brandImagePath',
            'tyreImagePath',
            'homeDeliverySession',
            'mostPopularRanges',
            'logoExists',
            'postcode',
            'modelImagePath',
            'breadcrumbs'
        ],
        mounted() {
			//removes loading placeholder - fixes CLS issues
            if (document.contains(document.querySelector('#loadingPlaceholder'))) {
			    document.querySelector('#loadingPlaceholder').style.display = 'none';
            }
        },
        computed: {
            manufacturerBackgroundImage() {
                let manufacturer_image = ('Backgrounds/Asda%20Tyres/Manufacturers/' + (this.manufacturer.slug) + '.jpg');
                return this.tyreImagePath + manufacturer_image;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .manufacturer-hero {
        background: #e9ecef !important;
        p, span {
            background-color: inherit !important;
        }
        .hero-img {
            max-width: 75%;
        }
    }
    .brand-image {
        max-width: 170px;
    }
    .title-text {
        @media screen and (min-width: 1200px) {
            max-width: 450px;
        }
    }
    .manufacturer-logo {
        background-color: #fff;
        @media screen and (min-width: 576px) {
            max-width: 150px;
            position: absolute;
            left: -85px;
            top: 80px;
        }
    }
    .main-content {
        .slimline {
            @media screen and (min-width: 992px) {
                margin-top: -35px !important;
            }
            position: relative;
        }
    }
    .models {
        .card {
            img {
                max-width: 75%;
                margin: 10px auto;
                max-height: 130px;
            }
        }
    }
</style>